module.exports = __webpack_public_path__ + "img/paper_fail.1141e77d.svg";